import axios from 'axios'
import Event from './Event.class'
import Question from './Test/Question.class'
import {Attempts, UserWithStatusTest} from './User.class'
import {get, has} from 'lodash'
import Simple from './SimpleName/Simple.class'
import ImageCrud from './ImageCrud.class'
import { REMOVE_IMAGE } from './constans'
import TourClass from './Tour.class'

const baseURL = '/api/test/'

export default class Test {
	/** @constructor
	 * @param {number | Object} init
	 */
	constructor (init = {}) {
		this.id = null
		this.setDefaultData()
		if (typeof init === 'number') {
			this.id = init
			this.getSingle().then()
		} else {
			this.setDefaultData(init)
		}
	}
	setDefaultData (init = {}) {
		if (!init) return

		this.id = get(init, 'id') ? init.id : null
		this.test_category = get(init, 'test_category') ? init.test_category : new Simple()
		this.logo = get(init, 'logo') ? init.logo : new ImageCrud(init.logo)
		this.new_logo = null
		this.category = get(init, 'category') ? init.category : null
		this.event = get(init, 'event') ? new Event(init.event) : new Event()
		this.try_count = get(init, 'try_count') ? init.try_count : 0
		this.description = get(init, 'description') ? init.description : ''
		this.name = get(init, 'name') ? init.name : ''
		this.certificate_at = get(init, 'certificate_at') ? init.certificate_at : null
		this.certificate_name = get(init, 'certificate_name') ? init.certificate_name : ''
		this.pass_level = get(init, 'pass_level') ? init.pass_level : 0
		this.pass_time = get(init, 'pass_time') ? init.pass_time : 0
		this.passed = get(init, 'passed') ? init.passed : 0
		this.tour = get(init, 'tour') ? new TourClass(init.tour) : null
		this.questions = get(init, 'questions') ? this.setQuestions(init.questions, !!this.tour) : []
		this.created_at = get(init, 'created_at') && this.isValidDate(new Date(init.created_at)) ? new Date(init.created_at) : null
		this.updated_at = get(init, 'updated_at') && this.isValidDate(new Date(init.updated_at)) ? new Date(init.updated_at) : null
		this.deleted_at = get(init, 'deleted_at') && this.isValidDate(new Date(init.deleted_at)) ? new Date(init.deleted_at) : null

		// not request
		this.isCreate = get(init, 'isCreate') ? init.isCreate : false
		this.front_url = has(init, 'front_url') ? `${init.front_url}/test/${this.id}` : false
		this.errors = {}
		this.result = has(init, 'result') ? this.createResultObject(init.result) : [] // deprecated
		this.attempts = has(init, 'attempts') ? new Attempts(init.attempts) : {} // new result field
	}

	static url = baseURL

	/**
	 * get all tests
	 * @param {Object} params
	 * @returns {Promise<{data: Test[]}>}
	 */
	static getAll (params) {
		return axios.get(baseURL, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(item => new Test(item))
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}
	/**
	 * get test by id
	 * @returns {Promise<void>}
	 */
	async getSingle () {
		try {
			const {data} = await axios.get(`${baseURL}admin/${this.id}`)
			this.setDefaultData(data.data)
		} catch (e) {
			console.error(e)
		}
	}
	/**
	 * get form data on create
	 * @returns {FormData}
	 */
	get formData () {
		const formData = new FormData()

		formData.append('test_category_id', this.test_category.id)
		formData.append('name', this.name)
		formData.append('description', this.description)
		formData.append('certificate_name', 'Базовый сертификат')

		if (this.new_logo) {
			if (this.new_logo === REMOVE_IMAGE) {
				formData.append('logo', '')
			} else {
				formData.append('logo', this.new_logo)
			}
		}

		if (!this.isTraining) {
			formData.append('try_count', this.try_count)
			if (!this.forTour) formData.append('pass_level', this.pass_level)
		}

		if (this.forTour) {
			formData.append('pass_level', 0)
			formData.append('pass_time', this.pass_time)
		}

		if (this.isCreate) {
			if (this.forTour) {
				formData.append('tour_id', this.tour.id)
			} else {
				formData.append('event_id', this.event.id)
			}
		}

		return formData
	}

	saveQuestions () {
		let updatedArr = []
		let createdArr = []
		let hasEmpty = false
		// this.deleteEmptyQuestion() // удалить незаполненые вопросы
		this.questions.forEach((questionItem, questionIndex) => {
			questionIndex++
			questionItem.question_number = questionIndex
			if (questionItem.id) {
				updatedArr.push(questionItem)
			} else {
				createdArr.push(questionItem)
			}

			if (!questionItem.hasAnswers) { // подсветить незаполненые ответы
				const errMsg = questionItem.question_type === 'conformity' ? 'Вопрос должен содержать соответствия!' : 'Вопрос должен содержать ответ(ответы)!'
				questionItem.errors = {
					emptyAnswers: errMsg
				}
				hasEmpty = true
			}
			questionItem.answers.forEach((answerItem, answerIndex) => {
				answerIndex++
				answerItem.answer_number = answerIndex
				// answerItem.deleteEmptyCompetence() // удалить незаполненые компетенции
			})
		})

		if (!hasEmpty) {
			const promiseList = []
			if (updatedArr.length) {
				promiseList.push(this.updateQuestions(updatedArr))
			}
			if (createdArr.length) {
				promiseList.push(this.createQuestions(createdArr))
			}

			return promiseList
		} else {
			return []
		}
	}
	formDataQuestions (arr, isUpdate = false) {
		let formData
		if (isUpdate) {
			formData = new URLSearchParams()
		} else {
			formData = new FormData()
		}

		arr.forEach((item, index) => {
			item.formData(formData, index)
		})

		return formData
	}
	updateQuestions (arr) {
		const formData = this.formDataQuestions(arr, true)
		return axios.put(`${baseURL}${this.id}/question`, formData)
	}
	createQuestions (arr) {
		const formData = this.formDataQuestions(arr)
		return axios.post(`${baseURL}${this.id}/question`, formData)
	}
	/**
	 * update test by id
	 * @returns {Promise}
	 */
	update () {
		return axios.post(`${baseURL}${this.id}`, this.formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return err.response
			})
	}
	updateEventId (eventId) {
		const formData = new FormData()
		formData.append('test[event_id]', eventId)
		return axios.post(`${baseURL}${this.id}`, formData)
	}
	updateTourId (tourId) {
		const formData = new FormData()
		formData.append('test[tour_id]', tourId)
		return axios.post(`${baseURL}${this.id}`, formData)
	}
	/**
	 * create test
	 * @returns {Promise}
	 */
	async create () {
		return await axios.post(`${baseURL}`, this.formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return err.response
			})
	}

	get urlencodedDeleteData () {
		let urlencoded = new URLSearchParams()
		urlencoded.append('test', 1)
		this.questions.forEach(questionItem => {
			urlencoded.append(`question[${questionItem.id}]`, 1)
			questionItem.answers.forEach(answerItem => {
				urlencoded.append(`answer[${answerItem.id}]`, 1)
			})
		})
		return urlencoded
	}
	/**
	 * delete current test
	 * @returns {Promise}
	 */
	delete () {
		return axios.delete(`${baseURL}${this.id}`, {
			params: this.urlencodedDeleteData,
			'Content-Type': 'application/x-www-form-urlencoded'
		})
	}

	copy (event) {
		return axios.post(`${baseURL}${this.id}/copy`, {
			event_id: event.id
		})
	}

	restore () {
		return axios.post(`${baseURL}${this.id}/restore`)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}

	get findEmptyQuestion () {
		return this.questions.findIndex(item => !item.question)
	}

	deleteEmptyQuestion () {
		while (this.findEmptyQuestion >= 0) {
			this.questions.splice(this.findEmptyQuestion, 1)
		}
	}

	/**
	 * @param {Array<Object>} arr
	 * @param {boolean} forTour
	 * @returns {Question[]}
	 */
	setQuestions (arr, forTour = false) {
		if (Array.isArray(arr) && arr.length) {
			const arrObjects = arr.map(item => new Question(item, forTour))
			return arrObjects.sort(function (a, b) {
				if (a.question_number > b.question_number) return 1
				if (a.question_number <= b.question_number) return -1
			})
		} else {
			return []
		}
	}

	isValidDate (date) {
		return date instanceof Date && !isNaN(date)
	}

	createErrors (obj) {
		let newObj = {}
		for (let key in obj) {
			const newKey = key.replace('test.', '')
			const newErrorStr = obj[key].reduce((accumulator, item) => {
				return accumulator + item
			}, '')

			newObj[newKey] = newErrorStr
		}
		this.errors = newObj
	}

	createResultObject (str) {
		if (typeof str === 'string') {
			if (!str) return []
			try {
				const json = JSON.parse(str)
				return json
			} catch (e) {
				console.error(e)
				return []
			}
		} else if (Array.isArray(str)) {
			return str
		} else {
			return []
		}
	}

	getUsers (params) {
		if (!this.id) return false

		return axios.get(`${baseURL}${this.id}/users`, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(item => new UserWithStatusTest(item))
				}
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}

	updateUsers (users, field, value) {
		if (
			typeof field !== 'string' ||
			!Array.isArray(users) ||
			!users.length
		) return

		const formData = new FormData()
		users.forEach(({id}) => {
			formData.append(`user[${id}][${field}]`, value)
		})

		return axios.post(`${baseURL}${this.id}/users/update`, formData)
	}

	get isTraining () {
		let category = null

		if (this.category && this.category.category_name) {
			category = this.category.category_name
		} else {
			category = this.test_category && this.test_category.name ? this.test_category.name : null
		}

		if (category) {
			return category.toLowerCase() === 'тренировочный'
		} else {
			return false
		}
	}

	exportAnswers () {
		return axios.post(`${baseURL}${this.id}/report`)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}

	get forTour () {
		return !!(this.tour && this.tour.id)
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Test.class.js